<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style lang="scss" scoped>
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
.wrap-tec .lists li {
  width: 33.3%;
}
@media screen and (max-width: 640px) {
  .wrap-tec .lists li {
    width: 100% !important;
    p {
      margin: 5px auto !important;
    }
  }
}
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>small RNA测序</h1>-->
<!--          <h2 class="mt10">small RNA sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>small RNA测序</h1>
      <h2 class="mt10">Small RNA Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">
        小RNA（small RNA）是一类重要的特殊调控非编码RNA，可通过多种途径（包括mRNA降解、翻译抑制、异染色质形成等）调控基因表达。通过构建小RNA文库采用illumina测序一次性获得几百万条的小RNA序列，快速鉴定特定组织或者特定时期下表达的已知小RNA以及预测新的小RNA，同时可对小RNA的表达、结构以及靶基因等方面进行深入分析，可与转录组测序结果进行联合分析研究小RNA参与的基因调控网络。      
      </p>
      <en-title title="应用领域" enTitle="Application" />
      <application-icon :iconList="iconList" :lines="2" menuTitle="small RNA测序"/>
      <en-title title="技术参数" enTitle="Specifications" />
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>Novaseq SE50</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_8.png">
          <h4>项目周期</h4>
          <p>30个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>10 M Reads</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30＞80% , Q20＞85%</p>
        </li>
      </ul>
      <en-title title="技术路线" enTitle="Testing Workflow" />
      <div class="tc con"><img src="@/assets/images/small_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/small_1.png"> </div>
      <en-title title="研究内容" enTitle="Bioinformatics Service" />
      <service-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :headerCellStyle="headerCellStyle"
      />
    </section>
    <new-consult
      title="样本制备与寄样"
      enTitle="Sample Requirement and Shipment"
      :samplingText="samplingText"
      :typeList="['sampling']"
    />
    <!-- <qk-consult type="Virus"/> -->
  </div>
</template>
<script>
import bread from "@/components/bread";
import ServiceTable from "./components/serviceTable";
import ApplicationIcon from "./components/applicationIcon";
export default {
  inject: ['reload'],
  components: {
    bread,
    ServiceTable,
    ApplicationIcon,
  },
  data () {
    return {
      samplingText: "擎科生物小RNA测序目前接收细胞、动物组织、植物组织等组织样本与提取好的total RNA。",
      tableColumn: [
        {
          prop: "method1",
        },
        {
          label: "小RNA标准生信分析",
          prop: "method2",
        },
      ],
      tableData: [
        {
          method1: `1) 数据过滤：对原始数据进行去除低质量、去除接头等处理得到备用的序列`,
          method2: `7) 与exon/intron区域进行比对，得到exon/intron的注释信息`,
        },
        {
          method1: `2) 长度分布统计：统计小RNA的长度分布`,
          method2: `8) novel miRNA预测：对未注释的序列进行novel miRNA预测`,
        },
        {
          method1: `3) 基因组比对：将clean reads定位到参考基因组序列上面（需要基因组参考序列）`,
          method2: `9) miRNA结构水平分析：碱基偏好性分析`,
        },
        {
          method1: `4) 已知miRNA鉴定：与miRBase 21中指定范围的miRNA比对`,
          method2: `10) miRNA家族分析（仅分析miRBase中有收录的物种）`,
        },
        {
          method1: `5) 非编码RNA比对：与Rfam 12.0中的序列进行比对，鉴定各类非编码RNA`,
          method2: `11) miRNA表达量水平分析：表达量统计、差异分析和聚类分析`,
        },
        {
          method1: `6) 与Repeat区域进行比对，得到Repeat的注释信息`,
          method2: `12) miRNA功能分析：miRNA靶基因预测和靶基因的功能注释分析`,
        },
      ],
      iconList: [
        {
          img:'ngs_second/transcriptome/smallRNA/icon_1',
          title:'动植物生长发育调控研究',
        },
        {
          img:'ngs_second/transcriptome/smallRNA/icon_2',
          title:'抗病抗逆调控研究',
        },
        {
          img:'ngs_second/transcriptome/smallRNA/icon_3',
          title:'生物性状及突变调控研究',
        },
        {
          img:'ngs_second/transcriptome/smallRNA/icon_4',
          title:'疾病发生调控机制',
        },
        {
          img:'ngs_second/transcriptome/smallRNA/icon_5',
          title:'寻找生物标记物',
        },
        {
          img:'ngs_second/transcriptome/smallRNA/icon_6',
          title:'靶向药物研究',
        },
      ],
    }
  },
  created() {
    this.reload()
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        row[1].colSpan = 2;
        if (columnIndex === 0) {
          return {
            display: "none",
          };
        }
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/smallRNA.vue